import React from 'react';
import SolutionRentalCompleteContainer from 'containers/SolutionRentalCompleteContainer/SolutionRentalCompleteContainer';

export default function SolutionRentalCompletePage() {
  return (
    <SolutionRentalCompleteContainer />
  )
}
